export const formatOrderCount = (orderCount: number) => {
  if (orderCount >= 1000) return `${orderCount / 1000}k`;
  return orderCount;
};
